var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconClose"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 3.20857L12.7914 2L8 6.79143L3.20857 2L2 3.20857L6.79143 8L2 12.7914L3.20857 14L8 9.20857L12.7914 14L14 12.7914L9.20857 8L14 3.20857Z",
    fill: "#ADBFDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseGray);
export default __webpack_public_path__ + "static/media/iconCloseGray.c003c0221764f2ebe4cb255eb944d7d3.svg";
export { ForwardRef as ReactComponent };